module.exports = __webpack_public_path__ + "static/media/infiniti-vest.73c9811e.svg";